import React from 'react';
import useDataSourceContext from '../../DataSource/useDataSourceContext';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import DataListViews from '../DataListViews';
import Icon from '../../Icon';

const DataListToolbar = () => {
  const {
    filterSelection,
    hasModule,
    isLoadingData,
    setShowFilterSelection,
    filters: filtersModule = {},
    views: viewsModule = {},
  } = useDataSourceContext();
  const { hasActiveFilters } = filtersModule;
  const { viewShortcuts } = viewsModule;

  const handleOpenFilterSelection = () => {
    setShowFilterSelection(true);
  };

  return (
    <Box display="flex" mx={-2} px={2} mb={2} style={{ overflow: 'auto' }} height={48}>
      <Box display="flex" flex={1}>
        {hasModule('views') && viewShortcuts && <DataListViews />}
      </Box>
      {!!filterSelection && (
        <IconButton
          color={!isLoadingData && hasActiveFilters() ? 'primary' : 'inherit'}
          size="small"
          onClick={handleOpenFilterSelection}
        >
          <Icon icon={['fal', 'filter']} />
        </IconButton>
      )}
    </Box>
  );
};

export default DataListToolbar;
